var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "aside",
    {
      staticClass: "filter",
      class: _vm.showfilters ? "open" : null,
      attrs: { id: "filter" }
    },
    [
      _c("div", { staticClass: "filter-header" }, [
        _c("h2", [_vm._v("Filter")]),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "js-filter-clear filter-clear hide-mobile",
            attrs: { href: "javascript:void(0)" },
            on: {
              click: function($event) {
                return _vm.clearFilters()
              }
            }
          },
          [_vm._v("clear all filters")]
        ),
        _vm._v(" "),
        _c("i", {
          staticClass: "icon icon-close filter-close hide-desktop",
          on: { click: _vm.updateShowFilters }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "filters", attrs: { id: "filters" } }, [
        _c("div", { staticClass: "filter-section" }, [
          _c(
            "a",
            {
              staticClass: "js-filter-clear filter-clear hide-desktop",
              attrs: { href: "javascript:void(0)" },
              on: {
                click: function($event) {
                  return _vm.clearFilters()
                }
              }
            },
            [_vm._v("clear all filters")]
          ),
          _vm._v(" "),
          _c("h3", [_vm._v("Category")]),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "filters-categories input-group" },
            _vm._l(_vm.categoryfilters, function(category) {
              return _c("li", { staticClass: "category" }, [
                _c("div", { staticClass: "form-group form checkox-input" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.filters.categories,
                        expression: "filters.categories"
                      }
                    ],
                    attrs: { id: "filter-" + category.ID, type: "checkbox" },
                    domProps: {
                      value: category.ID,
                      checked: Array.isArray(_vm.filters.categories)
                        ? _vm._i(_vm.filters.categories, category.ID) > -1
                        : _vm.filters.categories
                    },
                    on: {
                      change: function($event) {
                        var $$a = _vm.filters.categories,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = category.ID,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 &&
                              _vm.$set(
                                _vm.filters,
                                "categories",
                                $$a.concat([$$v])
                              )
                          } else {
                            $$i > -1 &&
                              _vm.$set(
                                _vm.filters,
                                "categories",
                                $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                              )
                          }
                        } else {
                          _vm.$set(_vm.filters, "categories", $$c)
                        }
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "filter-" + category.ID } }, [
                    _vm._v(_vm._s(category.Name))
                  ])
                ])
              ])
            }),
            0
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "filter-section" }, [
          _c("h3", [_vm._v("Date Range")]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group calendar-input from-date" }, [
            _c("label", { attrs: { for: "select-from-date" } }, [
              _vm._v("From")
            ]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.filters.from,
                  expression: "filters.from"
                }
              ],
              staticClass: "flatpickr flatpickr-input",
              attrs: { name: "from", placeholder: "Date" },
              domProps: { value: _vm.filters.from },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.filters, "from", $event.target.value)
                }
              }
            }),
            _vm._v(" "),
            _c("i", { staticClass: "icon icon-calendar" })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group calendar-input to-date" }, [
            _c("label", { attrs: { for: "select-to-date" } }, [_vm._v("To")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.filters.to,
                  expression: "filters.to"
                }
              ],
              staticClass: "flatpickr flatpickr-input",
              attrs: { name: "to", placeholder: "Date" },
              domProps: { value: _vm.filters.to },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.filters, "to", $event.target.value)
                }
              }
            }),
            _vm._v(" "),
            _c("i", { staticClass: "icon icon-calendar" })
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "filter-actions",
          class: _vm.filterActionsStuck ? "static" : ""
        },
        [
          _c(
            "button",
            {
              staticClass: "btn",
              on: {
                click: function($event) {
                  return _vm.applyFilters()
                }
              }
            },
            [_vm._v("Apply Filters")]
          ),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "js-filter-clear hide-mobile",
              attrs: { href: "javascript:void(0)" },
              on: {
                click: function($event) {
                  return _vm.clearFilters()
                }
              }
            },
            [_vm._v("Clear Filters")]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-26c2f57c", { render: render, staticRenderFns: staticRenderFns })
  }
}